export default "__VITE_ASSET__BM6OhsXv__"